var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
      { 'button-border' : _vm.hasBorder }, 
        'button-default', 
        _vm.backgroundColor,
        _vm.buttonTextColor, 
    ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.sendClick,"mouseover":function($event){_vm.isHovering = true},"mouseleave":function($event){_vm.isHovering = false}}},[(_vm.hasIcon)?_c('i',{class:_vm.icon}):_vm._e(),(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('div',{staticClass:"button-default-loading"},[_c('img',{attrs:{"src":"/images/loading-ummense.gif"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }